module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "part-no",
    attrs: {
      "id": "part01"
    }
  }, [_c('span', {
    staticClass: "t-bold"
  }, [_vm._v("PART I")])]), _vm._v(" "), _c('h2', {
    staticClass: "part-title"
  }, [_c('span', {
    staticClass: "s-bold"
  }, [_vm._v("Leadership Is Important Because It Affects All of Us")])]), _vm._v(" "), _c('p', {
    staticClass: "p-para"
  }, [_vm._v("“Leadership is not about a title or a designation. It’s about impact, influence, and inspiration.”")]), _vm._v(" "), _c('p', {
    staticClass: "p-author"
  }, [_vm._v("~ Robin S. Sharma")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a2b3892","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/part01.vue
// module id = 90
// module chunks = 0